<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <Header
      :showGoBack="true"
      :title="'Change PIN code'"
    />

    <main
      :class="'scrollable container'"
      :style="{paddingTop: '10px', paddingBottom: '20px'}"
    >
      <Input
        :leftIcon="KeySvg"
        :placeholder="'Old PIN code'"
        :containerStyle="{marginBottom: '10px'}"
      />
      <Input
        :leftIcon="KeySvg"
        :placeholder="'New PIN code'"
        :containerStyle="{marginBottom: '10px'}"
      />
      <Input
        :leftIcon="KeySvg"
        :placeholder="'Confirm new PIN code'"
        :containerStyle="{marginBottom: '14px'}"
      />

      <Button
        :title="'Change PIN code'"
        :onClick="() => $router.go(-1)"
      />
    </main>
  </div>
</template>

<script setup>
import {useOpacity} from '@/hooks';
import {Header} from '@/components';
import {Input} from '@/components';
import {KeySvg} from '@/assets/svg';
import {Background} from '@/components';
import {Button} from '@/components';
const opacity = useOpacity();
</script>
